// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.account-modal-container[data-v-4e310743] {\n  padding-top: 15px;\n}\n.modal-footer[data-v-4e310743] {\n  position: relative;\n}\n.app-version-number[data-v-4e310743] {\n  top: 30px;\n  left: 15px;\n  color: #555875;\n  font-size: 10px;\n  position: absolute;\n  font-weight: 500;\n  bottom: 45px;\n}\n.modal-title[data-v-4e310743] {\n  color: #55a9eb;\n}\n", ""]);
// Exports
module.exports = exports;
